import CustomTooltip from './CustomTooltip';

exports.init = function IconCell() {
  CustomTooltip('.icon-cell__item:not(.icon-cell__item--invisible)');
};
